import { useState, useEffect } from 'react';

function useDimensions(args) {
  const [dimensions, setDimensions] = useState(determineDimensions(args));
  useEffect(() => {
    setDimensions(determineDimensions(args));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [args.desiredDimensions?.width, args.desiredDimensions?.height, args.imageRef]);
  return dimensions;
}
function determineDimensions({
  imageRef,
  desiredDimensions
}) {
  if (desiredDimensions?.width && desiredDimensions?.height) {
    return {
      aspectRatio: desiredDimensions.height / desiredDimensions.width,
      maxWidth: desiredDimensions.width
    };
  } else if (imageRef?.current) {
    return {
      aspectRatio: imageRef.current.naturalHeight / imageRef.current.naturalWidth,
      maxWidth: desiredDimensions?.width ?? imageRef.current.naturalWidth
    };
  } else {
    return {
      aspectRatio: 0.33
    };
  }
}

export { useDimensions };
//# sourceMappingURL=useDimensions.js.map
